import { render, staticRenderFns } from "./380V220VPowerSupply.vue?vue&type=template&id=85a9916c&scoped=true&"
import script from "./380V220VPowerSupply.vue?vue&type=script&lang=js&"
export * from "./380V220VPowerSupply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a9916c",
  null
  
)

export default component.exports